<div class="gl-dashboard__title">
  <span>{{ 'dashboard.widgets.automaticGroups' | translate }}</span>
</div>
<ul class="gl-dashboard__list">
  <li>
    <span>{{ 'dashboard.widgets.activeGroups' | translate }}</span>
    <span class="value" *ngIf="scheduledClass['actives'] | lmsCheckNoData; else NoActiveData">{{
      scheduledClass['actives']
    }}</span>
    <ng-template #NoActiveData
      ><span class="value void">{{ 'dashboard.widgets.noData' | translate }}</span></ng-template
    >
  </li>
  <li>
    <span>{{ 'dashboard.widgets.endGroups' | translate }}</span>
    <span class="value" *ngIf="scheduledClass['closed'] | lmsCheckNoData; else NoClosedData">{{
      scheduledClass['closed']
    }}</span>
    <ng-template #NoClosedData
      ><span class="value void">{{ 'dashboard.widgets.noData' | translate }}</span></ng-template
    >
  </li>
  <li>
    <span>{{ 'dashboard.widgets.totalGroups' | translate }}</span>
    <span class="value" *ngIf="scheduledClass['total'] | lmsCheckNoData; else NoTotalData">{{
      scheduledClass['total']
    }}</span>
    <ng-template #NoTotalData
      ><span class="value void">{{ 'dashboard.widgets.noData' | translate }}</span></ng-template
    >
  </li>
</ul>
